import { Table } from "antd";
import { useStatsAssetCustomer } from "../../../api/hooks/stats";
import { CSVLink } from "react-csv";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { DATE_TIME_FORMAT } from "../../../utils/date";

function InventoryWithCustomers() {
  const { data: customerInventoryData } = useStatsAssetCustomer();

  const inventoryWTCustomersColumns = [
    {
      title: "Customer",
      dataIndex: ["customer", "name"],
      key: "customer.name",
      render: (text) => text ?? "-",
    },
    {
      title: "Order Count",
      dataIndex: "totalOrderCount",
      key: "totalOrderCount",
      render: (text) => text || 0,
    },
    {
      title: "Quantity",
      dataIndex: "totalQuantityWithCustomer",
      key: "totalQuantityWithCustomer",
      render: (text) => text || 0,
    },
  ];

  function getCustomerInventoryCSVData(customerInventoryData = []) {
    // Name: orders[].customer.name
    // OrderID: orders[].referenceId
    // Shipping Date:  orders[].assetsWithCustomer[].createdAt
    // Days with customer: days between shipping date and today
    // Tag: orders[].assetsWithCustomer[].asset.tag

    const res = [["Name", "Order ID", "SHP Date", "Days With Customer", "Tag"]];
    customerInventoryData.forEach((ci) => {
      const { orders = [] } = ci;
      orders?.forEach((order) => {
        const { assetsWithCustomer = [] } = order;
        res.push([order?.customer?.name, order?.referenceId]);
        assetsWithCustomer?.forEach((awc) => {
          res.push([
            undefined,
            undefined,
            dayjs(awc?.createdAt).format(DATE_TIME_FORMAT),
            dayjs().diff(awc?.createdAt, "day"),
            awc?.asset?.tag,
          ]);
        });
      });
    });

    return res;
  }

  // console.table(getCustomerInventoryCSVData(customerInventoryData));

  return (
    <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
      <div className="flex items-center justify-between gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-2 text-lg">
        <div>Inventory With Customers</div>
        <div className="flex items-center gap-5">
          {Boolean(customerInventoryData?.length) && (
            <CSVLink
              filename={"customer_inventory.csv"}
              data={getCustomerInventoryCSVData(customerInventoryData)}
            >
              <DownloadOutlined />
            </CSVLink>
          )}
          {/* <div className="flex items-center gap-2 text-center">
            <p className="text-xs">Assigned</p>
            <p className="font-bold">
              {customerInventoryData?.reduce((acc, inv) => {
                return acc + (inv?.totalQuantityWithCustomer || 0);
              }, 0) || 0}
            </p>
          </div> */}
        </div>
      </div>
      {/* <div className="flex flex-grow justify-between gap-6 divide-x px-6">
        <Table
          className="w-full"
          dataSource={customerInventoryData || []}
          columns={inventoryWTCustomersColumns}
          rowKey={"_id"}
          pagination={false}
          size="small"
        />
      </div> */}
      <div className="flex flex-grow justify-between gap-6 divide-x px-16">
        <div className="flex-grow text-center">
          <p className="">Order Count</p>
          <p className="font-bold">
            {customerInventoryData?.reduce((acc, inv) => {
              return acc + (inv?.totalOrderCount || 0);
            }, 0) || 0}
          </p>
        </div>
        <div className="flex-grow text-center">
          <p className="">Quantity</p>
          <p className="font-bold">
            {customerInventoryData?.reduce((acc, inv) => {
              return acc + (inv?.totalQuantityWithCustomer || 0);
            }, 0) || 0}
          </p>
        </div>
      </div>
    </div>
  );
}

export default InventoryWithCustomers;
